module.exports = __webpack_public_path__ + "img/act-of-emotion-3.fb6d139a.jpg";